export const queryKeys = {
    getCampaignDesignationsReportData: "getCampaignDesignationsReportData",
    getOrganizationReportCampaignLookups: "getOrganizationReportCampaignLookups",
  };